import { render, staticRenderFns } from "./itemNoStockRpt.vue?vue&type=template&id=62a4798e&scoped=true&"
import script from "./itemNoStockRpt.vue?vue&type=script&lang=js&"
export * from "./itemNoStockRpt.vue?vue&type=script&lang=js&"
import style0 from "./itemNoStockRpt.vue?vue&type=style&index=0&id=62a4798e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a4798e",
  null
  
)

export default component.exports